<div class="row row--service">
    <div class="col-md-6">
        <canvas #service></canvas>
    </div>
    <div class="col-md-6">
        <ul class="count-list">
            <li>
                <div class="count-list__dot" style="background: #f38600;"></div>
                <div class="count-list__detail">
                    <span>{{"dashboardLang.center" | translate}}</span>
                    <p app-animating-count class="no-space"
                    [count]="data?.centerServiceCount"
                    [skips]="data?.centerServiceCount"
                    [interval]="0"></p>
                </div>
            </li>
            <li>
                <div class="count-list__dot" style="background: #00599F;"></div>
                <div class="count-list__detail">
                    <span>{{"dashboardLang.state" | translate}}</span>
                    <p app-animating-count class="no-space"
                    [count]="data?.stateServiceCount"
                    [skips]="data?.stateServiceCount"
                    [interval]="0"></p>
                </div>
            </li>
        </ul>
    </div>
</div>